module.exports = __webpack_public_path__ + "static/media/circle.c5d5a675.svg";